import { motion } from "framer-motion";
import { fadeUp, revealScale, viewport } from "@/lib/motion";
import { TEAM } from "@/lib/data";

export const Team = () => {
  return (
    <section id="team" data-testid="team-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl mb-16 md:mb-20">
          <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
            className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-6">Meet Our Team</motion.p>
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1}
            className="font-serif font-light text-4xl sm:text-5xl leading-tight text-primary">
            Experienced advisors, devoted to your calling.
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 max-w-6xl">
          {TEAM.map((m, i) => (
            <motion.div key={m.name} data-testid={`team-member-${i}`}
              variants={revealScale} initial="hidden" whileInView="show" viewport={viewport}
              className="group">
              <div className="relative aspect-[4/5] overflow-hidden mb-5 bg-[hsl(var(--muted))]">
                <img src={m.img} alt={m.name}
                  className={`h-full w-full object-cover ${m.pos || "object-center"} grayscale-[0.2] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700`} />
                <div className="absolute inset-0 ring-1 ring-inset ring-[hsl(var(--gold)/0.4)]" />
              </div>
              <h3 className="font-serif text-xl md:text-2xl font-normal text-primary leading-tight">{m.name}</h3>
              <p className="text-sm text-gold mt-1">{m.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
